const TasksStyles = {
  tasks: {
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%",
    minHeight: "88.5vh",
    "@media (max-width:768px)": { padding: "10px" },
  },
  heading: {
    color: "#383D4E",
    fontSize: "20px",
    fontWeight: 400,
    fontFamily: "Playfair Display",
    lineHeight: "22px",
  },
  descriptionCell: {
    maxWidth: "100%",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  // Column styles
  transactionDateCell: {
    fontFamily: "Noto Sans",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
    whiteSpace: "initial",
  },
  statusCell: {
    fontFamily: "Noto Sans",
    fontSize: "14px",
  },
  moreVertIcon: {
    cursor: "pointer",
  },
  // Header and navigation styles
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 2,
  },
  backButtonContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  backButton: {
    color: "primary.main",
    fontSize: "2rem",
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.04)",
    },
    cursor: "pointer",
    borderRadius: "50%",
    p: 0.5,
    mr: 1,
  },
  subtitle: {
    color: "#666",
    ml:"0.5rem" ,
  },
  // Filter styles
  filterContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    background: "#fff",
    p: 2,
    borderRadius: 2,
    flexWrap: "wrap",
    rowGap: 2,
    columnGap: 2,
    "@media (max-width: 460px)": {
      flexDirection: "column",
      alignItems: "stretch",
      gap: 1,
    },
  },
  filterLabel: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    "@media (max-width: 460px)": {
      justifyContent: "center",
    },
  },
  filterLabelText: {
    fontWeight: 500,
  },
  select: {
    minWidth: 160,
    flex: "1 1 160px",
    maxWidth: "100%",
    "@media (max-width: 460px)": {
      minWidth: "100%",
      flex: "none",
    },
  },
  flexGrow: {
    flexGrow: 1,
    "@media (max-width: 460px)": {
      display: "none",
    },
  },
  requestCount: {
    color: "#888",
    minWidth: "fit-content",
    ml: "auto",
    textAlign: "right",
    mt: { xs: 1, sm: 0 },
    display: { xs: "none", sm: "block", "570": "none" },
    "@media (max-width: 460px)": {
      textAlign: "center",
      ml: 0,
      mt: 1,
    },
  },
  // Menu styles
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  deleteIcon: {
    fontSize: "20px",
  },
  // Dialog styles
  dialogTitle: {
    display: "flex",
    justifyContent: "flex-end",
  },
  closeIcon: {
    cursor: "pointer",
  },
  dialogContent: {
    display: "inline-flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    padding: "20px",
  },
  errorText: {
    color: "red",
  },
  // Table responsive styles
  tableContainer: {
    width: "100%",
    overflowX: "auto" as const,
    "@media (max-width: 570px)": {
      "& .MuiTable-root": {
        minWidth: "600px", // Ensure minimum width for readability
      },
      "& .MuiTableCell-root": {
        padding: "8px 4px",
      },
    },
  },
  // Column width styles for responsive design
  columnStyles: {
    transactionDate: {
      minWidth: "120px",
      maxWidth: "140px",
      "@media (max-width: 570px)": {
        minWidth: "100px",
        maxWidth: "120px",
      },
    },
    category: {
      minWidth: "120px",
      maxWidth: "150px",
      "@media (max-width: 570px)": {
        minWidth: "100px",
        maxWidth: "120px",
      },
    },
    requestName: {
      minWidth: "150px",
      maxWidth: "200px",
      "@media (max-width: 570px)": {
        minWidth: "120px",
        maxWidth: "150px",
      },
    },
    description: {
      minWidth: "200px",
      maxWidth: "300px",
      "@media (max-width: 570px)": {
        minWidth: "150px",
        maxWidth: "200px",
      },
    },
    status: {
      minWidth: "100px",
      maxWidth: "120px",
      "@media (max-width: 570px)": {
        minWidth: "80px",
        maxWidth: "100px",
      },
    },
    actions: {
      minWidth: "50px",
      maxWidth: "60px",
      "@media (max-width: 570px)": {
        minWidth: "40px",
        maxWidth: "50px",
      },
    },
  },
};

export default TasksStyles;
